<template>
<div>
  <offline @detected-condition="handleConnectivityChange"></offline>
  <modal-calc :show.sync="showCalc" headerClasses="justify-content-center">
      <h6 slot="header" class="title title-up">Calculadora</h6>
      <div id="calculator">
        <div class="calculator-logs">
          <span v-for="log in logs" :key="log">{{ log }}</span>
        </div>

        <input type="string" class="calculator-input" v-model="value" @keyup.enter="getResult()">

        <div class="calculator-row">
          <div class="calculator-col">
            <button class="calculator-btn gray action" @click="clear()">C</button>
          </div>
          <div class="calculator-col wide">
            <button class="calculator-btn gray action" @click="del()">del</button>
          </div>
          <div class="calculator-col">
            <button class="calculator-btn accent action" @click="addExpresion('/')">/</button>
          </div>
        </div>
        <div class="calculator-row">
          <div class="calculator-col">
            <button class="calculator-btn" @click="addExpresion(7)">7</button>
          </div>
          <div class="calculator-col">
            <button class="calculator-btn" @click="addExpresion(8)">8</button>
          </div>
          <div class="calculator-col">
            <button class="calculator-btn" @click="addExpresion(9)">9</button>
          </div>
          <div class="calculator-col">
            <button class="calculator-btn accent action" @click="addExpresion('*')">*</button>
          </div>
        </div>
        <div class="calculator-row">
          <div class="calculator-col">
            <button class="calculator-btn" @click="addExpresion(4)">4</button>
          </div>
          <div class="calculator-col">
            <button class="calculator-btn" @click="addExpresion(5)">5</button>
          </div>
          <div class="calculator-col">
            <button class="calculator-btn" @click="addExpresion(6)">6</button>
          </div>
          <div class="calculator-col">
            <button class="calculator-btn accent action" @click="addExpresion('-')">-</button>
          </div>
        </div>
        <div class="calculator-row">
          <div class="calculator-col">
            <button class="calculator-btn" @click="addExpresion(1)">1</button>
          </div>
          <div class="calculator-col">
            <button class="calculator-btn" @click="addExpresion(2)">2</button>
          </div>
          <div class="calculator-col">
            <button class="calculator-btn" @click="addExpresion(3)">3</button>
          </div>
          <div class="calculator-col">
            <button class="calculator-btn accent action" @click="addExpresion('+')">+</button>
          </div>
        </div>
        <div class="calculator-row">
          <div class="calculator-col wide">
            <button class="calculator-btn" @click="addExpresion(0)">0</button>
          </div>
          <div class="calculator-col">
            <button class="calculator-btn action" @click="addExpresion('.')">.</button>
          </div>
          <div class="calculator-col">
            <button class="calculator-btn accent action" @click="getResult()">=</button>
          </div>
        </div>
      </div>
      <template slot="footer">
          <p-button type="default" link @click="closeCalc()">Aceptar</p-button>
      </template>
  </modal-calc>
  <modal :show.sync="showInfo" headerClasses="justify-content-center">
      <h6 slot="header" class="title title-up">Información</h6>
      <p>{{message_computed}}</p>
      <template slot="footer">
          <p-button type="default" link @click="closeInfo()">Aceptar</p-button>
      </template>
  </modal>
  <modal :show.sync="showDescription" headerClasses="justify-content-center">
      <h6 slot="header" class="title title-up">Descripción del negocio</h6>
      <div class="form-group">
          <label>Descripción del negocio </label>
          <textarea   class="form-control"
                      tabindex="6"
                      type="text"
                      name="descripcion"
                      autocomplete="off"
                      placeholder="describa el negocio"
                      v-validate="modelValidations.customerStudyDescription"
                      :error="getError('descripcion')"
                      v-model="customerStudyDescription">
          </textarea>
      </div>
      <template slot="footer">
          <p-button type="default" link @click="closeDescription()">Aceptar</p-button>
      </template>
  </modal>
  <navbar v-model="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button id="minimizeSidebar" class="btn btn-icon btn-round" @click="minimizeSidebar">
          <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
          <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
        </button>
      </div>
      <div class="navbar-toggle">
        <navbar-toggle-button @click.native="toggleSidebar">

        </navbar-toggle-button>
      </div>
      <!-- <a class="navbar-brand" href="/">EMI</a> -->
      
    <div>
      <p v-if="offlineDisplay" style="color: orange;">Modo Offline</p>
    </div>

    </div>
    <template slot="navbar-menu">
      <!-- <form>
        <div class="input-group no-border">
          <input type="text" value="" class="form-control" placeholder="Search...">
          <div class="input-group-append">
            <div class="input-group-text">
              <i class="nc-icon nc-zoom-split"></i>
            </div>
          </div>
        </div>
      </form> -->
      <ul class="navbar-nav">
        <!-- <li class="nav-item">
          <a class="nav-link btn-magnify" href="#pablo">
            <i class="nc-icon nc-layout-11"></i>
            <p>
              <span class="d-lg-none d-md-block">Stats</span>
            </p>
          </a>
        </li> -->
        <!-- <drop-down icon="nc-icon nc-bell-55" tag="li"
                  position="right"
                  direction="none"
                  class="nav-item btn-rotate dropdown">
          <a slot="title"
              slot-scope="{isOpen}"
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              :aria-expanded="isOpen">
            <i class="nc-icon nc-bell-55"></i>
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
          </a>
          <a class="dropdown-item" href="#">Action</a>
          <a class="dropdown-item" href="#">Another action</a>
          <a class="dropdown-item" href="#">Something else here</a>
        </drop-down> -->
        <li v-if="!this.$store.state.emptyAssesment" class="nav-item mr-1 ml-1">
          <a class="btn btn-warning btn-block" @click="openCalc()">
            <i class="nc-icon nc-simple-add mr-2 "></i>
            <p>
              <span class="d-lg-none d-md-block">Calc.</span>
            </p>
          </a>
        </li>
        <li v-if="!this.$store.state.emptyAssesment" class="nav-item mr-1 ml-1">
          <a class="btn btn-warning btn-block" @click="openInfo()">
            <i class="nc-icon nc-pin-3 mr-2 "></i>
            <p>
              <span class="d-lg-none d-md-block">Info</span>
            </p>
          </a>
        </li>
        <li v-if="!this.$store.state.emptyAssesment" class="nav-item mr-1 ml-1">
          <a class="btn btn-warning btn-block" @click="openDescription()">
            <i class="nc-icon nc-bank mr-2 "></i>
            <p>
              <span class="d-lg-none d-md-block">Desc. negocio</span>
            </p>
          </a>
        </li>
        <li v-if="!this.$store.state.emptyAssesment" class="nav-item mr-1 ml-1">
          <!-- <a class="nav-link" @click="openMenu()">
            <i class="nc-icon nc-bank"></i>
            <p>
              <span class="d-lg-none d-md-block">Menú</span>
            </p>
          </a> -->
          <a class="btn btn-warning btn-block" @click="openMenu()">
            <i class="nc-icon nc-bullet-list-67 mr-2 "></i>
            <p>
              <span class="d-lg-none d-md-block">Menú</span>
            </p>
          </a>
        </li>
      </ul>
    </template>
  </navbar>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { Navbar, NavbarToggleButton, Modal, ModalCalc } from 'src/components/UIComponents'
  import expr from 'expression-eval'
  import offline from 'v-offline';
  Vue.use(offline);
  export default {
    components: {
      offline,
      Navbar,
      NavbarToggleButton,
      Modal,
      ModalCalc
    },
    data() {
      return {
        offlineDisplay: false,
        value: 0,
        logs:  [],
        offlineAlert: 'none',
        activeNotifications: false,
        showNavbar: false,
        showCalc: false,
        showInfo: false,
        showDescription: false,
        modelValidations: {
          customerStudyDescription: {
              required: false, 
              max: 256
          },  
        },
      }
    },
    watch: {
        
    },
    computed: {
            customerStudyDescription: {
                get: function() {
                  if (this.$store.state.actualAssesment != null && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies.length > 0) {
                    return this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].activityDescription;
                  }
                  else {
                    return 0
                  }
                },
                set: function(val) {
                    if(val.length <= 256) {
                        this.$store.commit('updateRequestStudyDescription', val)
                    }
                    else {
                      this.$store.commit('updateRequestStudyDescription', val.substr(0,256))
                      this.$forceUpdate()
                    }
                }
            },
            message_computed () {
                if (this.$store.state.isCustomer && !this.$store.state.emptyAssesment && this.$store.state.actualAssesment != null) {
                  if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerName != null) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy >= 0) {
                      var actualStudy = this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy + 1;
                      return 'Realizando estudio número '+ actualStudy +' para el cliente: '+this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerName;
                    }
                    else {
                      return 'Iniciando estudio para el cliente: '+this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerName;
                    }
                  }
                  return 'Estamos iniciando la evaluación'
                }
                else if (this.$store.state.isGuarantor && !this.$store.state.emptyAssesment && this.$store.state.actualAssesment != null && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors.length > 0) {
                  if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].customerName != null) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].actualStudy >= 0) {
                      var actualStudy = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].actualStudy + 1;
                      return 'Realizando estudio número '+ actualStudy +' para el codeudor: '+this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].customerName;
                    }
                    else {
                      return 'Iniciando estudio para el codeudor: '+this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].customerName;
                    }
                  }
                  return 'Se está iniciando el codeudor de la evaluación'
                }
                else {
                  return 'No ha iniciado ninguna evaluación'
                }
            },
    },
    methods: {
      // Función que verifica si hay internet y muestra el mensaje permanente
      handleConnectivityChange(status) {
        if(status == false)
        {
          this.offlineDisplay = true;
        }
        else
        {
          this.offlineDisplay = false;
        }
      },
      addExpresion(e) {
        if ( Number.isInteger(this.value) )
          this.value = ''; 
        this.value += e;
      },
      getResult() {
        if (this.value != '0') {
          let log = this.value;
          try {
            const ast = expr.parse(this.value);
            this.value =  expr.eval(ast);
            if (isNaN(this.value) || this.value == 'Infinity') {
              this.value = 0;
              this.showNotificationError('La operación no se puede realizar');
            }
            else {
              if (this.logs.length == 5) {
                this.logs.shift();
              }
              this.logs.push( log + `=${this.value}` );
            }
          }
          catch(error) {
            this.showNotificationError('La operación no se puede realizar'); 
          }
        }
      },
      clear() {
        this.value = 0;
      },
      del() {
        if (this.value != 0 && typeof this.value == 'string') {
          this.value = this.value.slice(0, -1);
        }
      },
      showNotificationError (message) {
          this.$notify(
          {
              message: message,
              icon: 'nc-icon nc-glasses-2',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
          })
      },
      openCalc () {
        this.showCalc = true;
      },
      openInfo () {
        this.showInfo = true;
      },
      openDescription () {
        this.showDescription = true;
      },
      openMenu () {
        this.$router.push('/asessments/menu');
        this.toggleNavbar();
      },
      closeCalc () {
        this.showCalc = false;
        this.logs.slice()
        this.toggleNavbar();
      },
      closeInfo () {
        this.showInfo = false;
        this.toggleNavbar();
      },
      closeDescription () {
        this.showDescription = false;
        this.toggleNavbar();
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown() {
        this.activeNotifications = false
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar() {
        this.$sidebar.toggleMinimize()
      },
      toggleNavbar() {
        this.showNavbar = !this.showNavbar;
      },
      /*** 
       * Función que permite visualizar los errores en cada campo del input
       */
      getError (fieldName) {
          return this.errors.first(fieldName)
          console.info(this.errors)
      },
    }
  }

</script>
<style lang="scss">
$darker: #2f2f31;
$dark: #424345;
$gray: #616163;
$white: #fff;
$light: #D4D4D2;
$accent: #f49e3f;

*, ::after, ::before {
  box-sizing: border-box;
}

//  CALCULATOR  \\
#calculator {
  width: 100%;
  margin: 0 auto;
  display: flex;
  padding: 0;
  max-width: 100%;
  min-width: 100%;
  flex-direction: column;
  background-color: $darker;

  .calculator-logs {
    height: 80px;
    display: flex;
    position: relative;
    overflow: hidden;
    align-items: flex-end;
    flex-direction: column;
    justify-content: flex-end;
    &:before {
      top: 0;
      left: 0;
      right: 0;
      height: 48px;
      content: '';
      z-index: 5;
      position: absolute;      
      background: linear-gradient(to bottom, $darker, rgba($darker, 0));
    }
    span {
      color: $light;
      opacity: .75;
      display: block;
      font-size: .8rem;
      text-align: right;
      margin-top: .4rem;
      line-height: 1;
      font-weight: lighter;
    }
  }

  .calculator-input {
    color: $light;
    width: 100%;
    border: none;
    padding: .8rem;
    display: block;
    font-size: 2.4rem;
    background: none;
    text-align: right;
    font-weight: lighter;
    &:focus, &:active {
      outline: none;
    }
  }

  .calculator-row {
    display: flex;
    padding: 0;
    justify-content: space-around;
    .calculator-col {
      flex: 1;
      box-shadow: 0 0 0 1px $darker;
      &.wide { flex: 2; }
    }
  }

  .calculator-btn {
    width: 100%;
    color: $light;
    border: none;
    cursor: pointer;
    padding: .8rem;
    outline: none;
    font-size: 1.6rem;
    transition: all .3s ease-in-out;
    font-weight: 200;
    justify-content: center;
    background-color: $gray;
    &.accent { background-color: $accent; color: $white; }
    &.gray { background-color: $dark; }
    &.action { }
    &:active {
      background-color: $darker;
    }
  }

}
</style>
